module.exports = __webpack_public_path__ + "img/class3.b913abe5.png";